import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LOCALE_ID, NgModule, Optional, SkipSelf } from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthInterceptor } from './authentication/auth-interceptor';
import { IconsRegistry } from './icons-registry';
import { I18nInterceptor } from './localization/i18n.interceptor';
import { PaginatorIntl } from './localization/paginator-intl.service';
import { getCookie } from './utils';

@NgModule({
  imports: [],
  providers: [
    {
      provide: LOCALE_ID,
      useFactory: () => getCookie('SPARROW_USE_LANGUAGE') || 'en',
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: I18nInterceptor, multi: true },
    // CDK v21 renders overlays via the native Popover API by default, which moves
    // the backdrop inside the overlay host and changes positioning. That breaks our
    // structure-dependent overlay styles (e.g. the mobile nav menu). Opt out to keep
    // the classic overlay DOM/positioning that the existing CSS targets.
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    [{ provide: MatPaginatorIntl, useClass: PaginatorIntl }],
    [
      {
        provide: MAT_DIALOG_DEFAULT_OPTIONS,
        useValue: {
          ...new MatDialogConfig(),
          hasBackdrop: true,
          panelClass: 'sparrow-dialog-panel',
          maxWidth: '100vw',
          width: 'auto',
          restoreFocus: true,
        },
      },
    ],
  ],
})
export class CoreModule {
  constructor(
    @Optional() @SkipSelf() parentModule: CoreModule,
    matIconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
  ) {
    this.throwIfAlreadyLoaded(parentModule, 'CoreModule');
    IconsRegistry.registerIcons(matIconRegistry, sanitizer);
  }

  private throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
    if (parentModule) {
      throw new Error(`${moduleName} has already been loaded. Import Core modules in the AppModule only.`);
    }
  }
}
